module.exports = __webpack_public_path__ + "img/09.61209269.png";